import { isNil } from "ramda";

import { HospitalConfiguration } from "types";

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export const daysAgo = (isoDate: string): number =>
  Math.round(Math.abs((new Date(isoDate).getTime() - Date.now()) / ONE_DAY_MS));

export const getNormalRanges = (hospitalConfig?: Maybe<HospitalConfiguration>): Maybe<NormalRanges> => {
  if (isNil(hospitalConfig)) return null;
  const { haemoglobinRangeFemale, haemoglobinRangeMale, neutrophilRange, plateletRange, wbcRange, granulocyteRange } =
    hospitalConfig;
  return { haemoglobinRangeFemale, haemoglobinRangeMale, neutrophilRange, plateletRange, wbcRange, granulocyteRange };
};

export const isPresentObject = <T, N = unknown>(arg: T | N): arg is T => {
  return arg && typeof arg === "object" && !Array.isArray(arg);
};

export const isNotInFuture = (isoDateString: string) => {
  const inputDate = new Date(isoDateString);
  const now = new Date();

  return inputDate <= now;
};

export const dateTimeToTimestamp = ({
  timeRecorded,
  dateRecorded,
}: {
  timeRecorded: string;
  dateRecorded: string;
}): string => {
  const recordDate = new Date(dateRecorded);
  const timeSegments = timeRecorded.split(":");
  recordDate.setHours(Number(timeSegments[0]), Number(timeSegments[1]));
  return recordDate.toISOString();
};

export const toNumber = (n?: string | number): number | undefined => {
  if (isNil(n)) return undefined;
  const result = typeof n === "number" ? n : parseFloat(n);
  if (Number.isNaN(result)) return undefined;
  return result;
};

export const startDownload = (url: string) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = url.split("/").pop() ?? "";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const EMPTY_RECORD: Record<string, unknown> = {};

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  Object.prototype.toString.call(value) === Object.prototype.toString.call(EMPTY_RECORD);
